// Mirrors the legacy watchEditUser localStorage seeding — only keeps the one
// flag that still gates a live popup (the rest have date gates that expired or
// no readers left). See TEMP-17004 audit.
export const suppressPostSignupPopups = (userId: string): void => {
  localStorage.setItem(`candidateSortAnnouncement-${userId}`, 'false');
};
